<template>
    <v-container :fluid="$vuetify.breakpoint.md">
        <v-row justify="center" v-if="user.status !== 103">
            <v-col cols="12" md="10">
                <v-card flat class="px-sm-6 py-sm-4">
                    <v-row justify="center">
                        <v-col md="10" class="text-center">
                            <h2 class="mt-8">No puedes agendar en este momento.</h2>
                            <h3 class="mt-4">Debes completar el formulario de verificación para poder solicitar ayuda.</h3>
                            <v-btn class="my-12" color="primary" to="/profile/edit">Completar Perfil</v-btn>
                        </v-col>
                    </v-row>
                </v-card>
            </v-col>
        </v-row>
        <v-row justify="center" v-else>
            <v-form ref="form" @submit.prevent="submit" lazy-validation v-model="valid">
                <v-col cols="12" md="10">
                    <v-card flat width="100%">
                        <v-card-title class="d-block text-center font-weight-bold grey--text text--darken-2" style="word-break: normal">DA EL PRIMER PASO</v-card-title>
                        <v-card-subtitle class="text-center">Sin importar dónde estés, te ayudamos a través de nuestros distintos canales de contacto.</v-card-subtitle>
                        <v-card-text class="py-0 text-center">
                            <v-row justify="center" v-if="user.status === 103">
                                <v-col cols="12" md="10">
                                    <h4>{{ labels.td + ': ' + user.td }}</h4>
                                    <h4>{{ labels.nd + ': ' + user.nd }}</h4>
                                    <h4>{{ labels.name + ': ' + user.name }}</h4>
                                    <h4>{{ labels.lname + ': ' + user.lname }}</h4>
                                    <h4>{{ labels.email + ': ' + user.email }}</h4>
                                    <h4>{{ labels.phone + ': +57' + user.phone }}</h4>
                                </v-col>
                            </v-row>
                            <v-row justify="center" v-else>
                                <v-col cols="12" sm="6" md="5">
                                    <v-select
                                        :label="labels.td"
                                        :items="dni"
                                        name="td"
                                        v-model="form.td"
                                        :error-messages="errors.td"
                                        :disabled="loading"
                                        :rules="[rules.required('td')]"
                                        @select="clearErrors('td')"
                                        prepend-icon="mdi-clipboard-text"
                                        item-text="name"
                                        item-value="value">
                                        <template v-slot:selection="{ item }">
                                            <v-flex class='ml-1'>{{ item.value }} - {{ item.name }}</v-flex>
                                        </template>
                                        <template v-slot:item="{ item }">
                                            <v-list-item-content>
                                                <v-list-item-title>{{ item.value }} - {{ item.name }}</v-list-item-title>
                                            </v-list-item-content>
                                        </template>
                                    </v-select>
                                </v-col>
                                <v-col cols="12" sm="6" md="5">
                                    <v-text-field
                                        v-if="form.td === 'NIT'"
                                        :label="labels.nd"
                                        v-model="form.nd"
                                        type="text"
                                        name="nd"
                                        :error-messages="errors.nd"
                                        :rules="[rules.required('nd'), rules.equal('nd', 13, 10, 'El')]"
                                        :disabled="loading"
                                        prepend-icon="mdi-ballot"
                                        @input="clearErrors('nd')"
                                        v-mask="nit"/>
                                    <v-text-field
                                        v-else
                                        :label="labels.nd"
                                        v-model="form.nd"
                                        type="text"
                                        name="nd"
                                        :error-messages="errors.nd"
                                        :rules="[rules.required('nd'), rules.min('nd', 5, 'El'), rules.max('nd', 20, 'El')]"
                                        :disabled="loading"
                                        prepend-icon="mdi-ballot"
                                        @input="clearErrors('nd')"/>
                                </v-col>
                                <v-col cols="12" sm="6" md="5">
                                    <v-text-field
                                        :label="labels.name"
                                        type="text"
                                        name="name"
                                        v-model="form.name"
                                        :error-messages="errors.name"
                                        :rules="[rules.required('name'), rules.max('name', 120, 'El')]"
                                        :disabled="loading"
                                        @input="clearErrors('name')"
                                        prepend-icon="mdi-account-circle"/>
                                </v-col>
                                <v-col cols="12" sm="6" md="5">
                                    <v-text-field
                                        :label="labels.lname"
                                        type="text"
                                        name="lname"
                                        v-model="form.lname"
                                        :error-messages="errors.lname"
                                        :rules="[rules.required('lname'), rules.max('lname', 120, 'El')]"
                                        :disabled="loading"
                                        @input="clearErrors('lname')"
                                        prepend-icon="mdi-account-circle"/>
                                </v-col>
                                <v-col cols="12" sm="6" md="5">
                                    <v-text-field
                                        :label="labels.email"
                                        type="email"
                                        name="email"
                                        v-model="form.email"
                                        :error-messages="errors.email"
                                        :rules="[rules.required('email'), rules.mail('email')]"
                                        :disabled="loading"
                                        @input="clearErrors('email')"
                                        prepend-icon="mdi-email"
                                        readonly/>
                                </v-col>
                                <v-col cols="12" sm="6" md="5">
                                    <v-text-field
                                        :label="labels.phone"
                                        v-model="form.phone"
                                        type="tel"
                                        name="phone"
                                        placeholder="301 2345678"
                                        :error-messages="errors.phone"
                                        :rules="[rules.required('phone'), rules.equal('phone', 11, 10, 'El')]"
                                        :disabled="loading"
                                        prepend-icon="mdi-cellphone"
                                        @input="clearErrors('phone')"
                                        v-mask="mask"/>
                                </v-col>
                            </v-row>
                        </v-card-text>
                    </v-card>
                </v-col>
                <v-col cols="12" md="10">
                    <v-card flat width="100%">
                        <v-card-title class="d-block text-center font-weight-bold grey--text text--darken-2" style="word-break: normal">{{ labels.title + ': ' + form.title }}</v-card-title>
                        <v-card-text class="py-0 text-center">
                            <v-row justify="center">
                                <v-col cols="12" md="10">
                                    <v-textarea
                                        :label="labels.description"
                                        v-model="form.description"
                                        name="description"
                                        counter="1000"
                                        :error-messages="errors.description"
                                        :disabled="loading"
                                        :rules="[rules.req('description'), rules.min('description', 20, 'La'), rules.max('description', 1000, 'La')]"
                                        prepend-inner-icon="mdi-clipboard-text"
                                        @input="clearErrors('description')"
                                        no-resize
                                        rows="5"
                                        filled/>
                                </v-col>
                            </v-row>
                        </v-card-text>
                        <v-card-actions class="align-content-center">
                            <v-row justify="center" class="mx-0">
                                <v-col cols="12" md="10">
                                    <v-btn type="submit" :loading="loading" :disabled="loading || !valid"
                                           color="primary" large block>
                                        <v-icon>mdi-shield-plus</v-icon>&nbsp;&nbsp;SOLICITAR
                                    </v-btn>
                                </v-col>
                            </v-row>
                        </v-card-actions>
                    </v-card>
                </v-col>
            </v-form>
        </v-row>
    </v-container>
</template>

<script>
import axios from 'axios';
import Form from "../helpers/form";
import { mask } from "vue-the-mask";

export default {
    name: "Service",
    props: [ 'user' ],
    mixins: [ Form ],
    directives: { mask },
    data: () => ({
        loading: true,
        dni: [
            { name: 'Cedula de Ciudadania', value: 'CC' },
            { name: 'Cedula de Extranjeria', value: 'CE' },
            { name: 'Número de Identificación Tributaria', value: 'NIT' }
        ],
        labels: {
            td: 'Tipo de Documento',
            nd: 'Número de Documento',
            name: 'Nombre(s)',
            lname: 'Apellido(s)',
            email: 'Correo Electrónico',
            phone: 'Telefono',
            title: 'Servicio',
            description: 'Cuentanos tu Caso',
            base: 'Valor',
            tax: 'Impuesto',
            amount: 'Total',
            currency: 'Moneda'
        },
        form: {
            td: null,
            nd: null,
            name: null,
            lname: null,
            email: null,
            phone: null,
            title: 'Asesoría y Analisis del Caso',
            description: null,
            base: 20000,
            tax: 3800,
            amount: 23800,
            currency: 'COP'
        },
        nit: '###.###.###-#',
        mask: '### #######'
    }),
    mounted() {
        this.getUser();
    },
    watch: {
        user() {
            this.getUser();
        }
    },
    methods: {
        getUser() {
            this.loading = true;
            axios.get('/api/profile').then((res) => {
                this.form.td = res.data.user.td;
                this.form.nd = res.data.user.nd;
                this.form.name = res.data.user.name;
                this.form.lname = res.data.user.lname;
                this.form.email = res.data.user.email;
                this.form.phone = res.data.user.phone;
            }).catch(err => {
                this.handleErrors(err.response.data.errors);
            }).then(() => {
                this.loading = false;
            });
        },
        submit() {
            if (this.$refs.form.validate()) {
                this.loading = true;

                axios.post('/api/services', this.form)
                    .then((res) => {
                        this.$toast.success(res.data.status, { icon: 'mdi-check-circle' });
                        this.$router.push({ name: 'PaymentView', params: { id: res.data.id } });
                    }).catch(err => {
                        this.handleErrors(err.response.data.errors);
                    }).then(() => {
                        this.loading = false;
                    });
            }
        }
    }
}
</script>

<style scoped>

</style>
